var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"m5 10 3.33 3L15 7"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }